import { Download, ExternalLink, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { AuthImg } from "@/components/studio/AuthImg";
import { downloadBlob, fmtDate } from "@/lib/api";

export const BundleFiles = ({ b, busy, onBuild, onPublish, onUnpublish }) => {
  const f = b.files || {};
  const sync = b.store_sync || {};
  const live = b.published && sync.status === "done";
  const slug = b.title.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "") || "bundle";
  return (
    <div className="border border-[#2A2325]/10 bg-[#FFFDF9] p-6 space-y-5" data-testid="bundle-files">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <div className="eyebrow">Bundle PDF &amp; ebook</div>
          <p className="text-sm text-[#5C5255] mt-1" data-testid="bundle-built-at">
            {f.built_at ? `${f.page_count} pages · A4 · built ${fmtDate(f.built_at)}` : "Not built yet"}
          </p>
          {f.built_at && !f.epub_path && <p className="text-xs text-[#9A6B2F] mt-1" data-testid="bundle-epub-missing">Rebuild to add the bundle ebook.</p>}
        </div>
        <div className="flex gap-2">
          <Button variant="outline" className="rounded-none gap-2" disabled={busy} onClick={onBuild} data-testid="bundle-build-btn">
            <RefreshCw size={14} className={busy ? "animate-spin" : ""} /> {f.built_at ? "Rebuild" : "Build"} bundle PDF
          </Button>
          {f.pdf_path && (
            <Button variant="outline" className="rounded-none gap-2" onClick={() => downloadBlob(`/bundles/${b.id}/pdf`, `${slug}-bundle.pdf`)} data-testid="bundle-download-btn">
              <Download size={14} /> PDF
            </Button>
          )}
          {f.epub_path && (
            <Button variant="outline" className="rounded-none gap-2" onClick={() => downloadBlob(`/bundles/${b.id}/epub`, `${slug}-bundle.epub`)} data-testid="bundle-epub-download-btn">
              <Download size={14} /> Ebook (EPUB)
            </Button>
          )}
        </div>
      </div>
      {b.stale && <p className="text-sm bg-[#F3E5AB]/60 px-3 py-2" data-testid="bundle-stale-note">Titles have changed since this PDF was built. Rebuild or update the store to include them.</p>}
      {f.preview_paths?.length > 0 && (
        <div className="grid grid-cols-3 gap-3" data-testid="bundle-previews">
          {f.preview_paths.map((_, i) => (
            <AuthImg key={i} path={`/bundles/${b.id}/preview/${i + 1}.png`} version={f.built_at} alt={`Page ${i + 1}`} className="w-full aspect-[210/297] border border-[#2A2325]/10" testId={`bundle-preview-${i + 1}`} />
          ))}
        </div>
      )}
      <div className="border-t border-[#2A2325]/10 pt-5 flex flex-wrap items-center gap-3">
        {sync.status === "running" ? (
          <span className="text-sm" data-testid="bundle-sync-running">Sending to softspinepress.com…</span>
        ) : (
          <Button className="rounded-none bg-[#5E2B38] hover:bg-[#4A2029]" onClick={onPublish} data-testid="bundle-publish-btn">
            {live ? "Update bundle on the store" : "Publish to softspinepress.com"}
          </Button>
        )}
        {live && sync.url && (
          <a href={sync.url} target="_blank" rel="noreferrer" className="text-sm underline inline-flex items-center gap-1" data-testid="bundle-store-link">
            {sync.store_status === "draft" ? "Draft" : "Live"} on softspinepress.com <ExternalLink size={12} />
          </a>
        )}
        {live && <Button variant="ghost" className="rounded-none underline" onClick={onUnpublish} data-testid="bundle-unpublish-btn">Unpublish</Button>}
        {sync.status === "failed" && <p className="text-sm text-[#9B2C2C] w-full" data-testid="bundle-sync-error">Store sync failed: {sync.error}</p>}
      </div>
    </div>
  );
};
